<template>
    <div>
        <dx-grid
            url="foodDistributionLogs"
            :columns="columns"
            :title="title"
            ref="grid"
        ></dx-grid></div
></template>
<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Logs",
        columns: [
            {
                label: "Family ID",
                field: "accountID",
                visible: true,
                filterValues: [],
                link: "FoodDistributionFamilyView",
                format: "",
                template: "link-cell-template",
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Source",
                field: "source",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "User",
                field: "userName",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
        ],

        actions: [],
    }),
    created() {
        this.user = this.$store.state.authentication.user;
    },
    mounted() {},
    methods: {},
};
</script>
